import { render } from "./CookiesIcon.vue?vue&type=template&id=781340a9&ts=true"
import script from "./CookiesIcon.vue?vue&type=script&lang=ts"
export * from "./CookiesIcon.vue?vue&type=script&lang=ts"

import "./CookiesIcon.vue?vue&type=style&index=0&id=781340a9&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__